import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";
import { financeLocale } from "./components/FinanceLocale";

const ExpensesPage = lazy(() => import("./pages/ExpensesPage/ExpensesPage"));
const ExpensePage = lazy(() => import("./pages/ExpensePage/ExpensePage"));
const PaymentsPage = lazy(() => import("./pages/PaymentsPage/PaymentsPage"));
const IncomePage = lazy(() => import("./pages/ReceivablesPage/ReceivablesPage"));
const CapitalPage = lazy(() => import("./pages/ReceivablesPage/CapitalPage"));
const ReceivablePage = lazy(() => import("./pages/ReceivablePage/ReceivablePage"));
const SummaryPage = lazy(() => import("./pages/SummaryPage/SummaryPage"));
const AccountingPage = lazy(() => import("./pages/AccountingPage/AccountingPage"));
const TaxPage = lazy(() => import("./pages/TaxPage/TaxPage"));

export const expensesModule: FrontModule = {
  id: "expenses", version: "0.3.0", permission: "expenses.read",
  label: "Finanzas", icon: "wallet",
  description: "Controla ingresos, costos, gastos y aportes de capital con su historial de pagos.",
  routes: [
    { path: "/expenses", Component: financeLocale(ExpensesPage) },
    { path: "/expenses/income", Component: financeLocale(IncomePage) },
    { path: "/expenses/capital", Component: financeLocale(CapitalPage) },
    { path: "/expenses/receivables/:receivableId", Component: financeLocale(ReceivablePage) },
    { path: "/expenses/payments", Component: financeLocale(PaymentsPage) },
    { path: "/expenses/summary", Component: financeLocale(SummaryPage) },
    { path: "/expenses/records/:expenseId", Component: financeLocale(ExpensePage) },
    { path: "/expenses/accounting", Component: financeLocale(AccountingPage) },
    { path: "/expenses/taxes", Component: financeLocale(TaxPage) },
  ],
  menu: [
    { id: "expenses.taxes", label: "Impuestos y SII", icon: "file", path: "/expenses/taxes", permission: "expenses.read", description: "Perfil tributario y preparación de F29 y F22" },
    { id: "expenses.accounting", label: "Contabilidad", icon: "chart", path: "/expenses/accounting", permission: "expenses.read", description: "Libro diario, mayor y balance de comprobación" },
    { id: "expenses.income", label: "Ingresos", icon: "wallet", path: "/expenses/income", permission: "expenses.read", description: "Contratos externos y ventas de servicios" },
    { id: "expenses.capital", label: "Capital", icon: "users", path: "/expenses/capital", permission: "expenses.read", description: "Compromisos de integrantes y cuotas" },
    { id: "expenses.records", label: "Gastos", icon: "wallet", path: "/expenses", permission: "expenses.read", description: "Gastos y saldos pendientes" },
    { id: "expenses.payments", label: "Pagos", icon: "users", path: "/expenses/payments", permission: "expenses.read", description: "Pagos realizados por el equipo" },
    { id: "expenses.summary", label: "Resumen", icon: "chart", path: "/expenses/summary", permission: "expenses.read", description: "Finanzas por período, categoría e integrante" },
  ],
};
export default expensesModule;
